import { type FC } from "react"
import { useForm } from "react-hook-form"

import type { GoodsReceiptFilterFormValues } from "../../types"

import { GoodsReceiptWarehouseFilter } from "./GoodsReceiptWarehouseFilter"

import { SearchFilterDrawer } from "@/components/common/SearchFilterDrawer/SearchFilterDrawer"
import type { Option } from "@/types/form-fields"

interface GoodsReceiptFilterDrawerProps {
  isOpen: boolean
  warehouseAreaIds: string[]
  warehouseOptions: Option<string>[]
  isWarehousesFetching: boolean
  onToggle: () => void
  onChange: (warehouseIds: string[]) => void
  onClear: () => void
}

export const GoodsReceiptFilterDrawer: FC<GoodsReceiptFilterDrawerProps> = ({
  isOpen,
  warehouseAreaIds,
  warehouseOptions,
  isWarehousesFetching,
  onToggle,
  onChange,
  onClear,
}) => {
  const { control } = useForm<GoodsReceiptFilterFormValues>({
    defaultValues: {
      warehouseAreaIds,
    },
  })

  return (
    <SearchFilterDrawer open={isOpen} toggleDrawer={onToggle} clear={onClear} testId='filter-drawer'>
      <GoodsReceiptWarehouseFilter
        control={control}
        isFetching={isWarehousesFetching}
        options={warehouseOptions}
        selectedValues={warehouseAreaIds}
        onChange={onChange}
      />
    </SearchFilterDrawer>
  )
}
